import { applicationNonBorrowerEntityApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const NON_BORROWER_ENTITIES_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/nonBorrowerEntities`,
  {
    CREATE_ENTITY: 'CREATE_ENTITY',
    EDIT_ENTITIES: 'EDIT_ENTITIES',
    DELETE_ENTITY: 'DELETE_ENTITY',
  },
);

export const editNonBorrowerEntitiesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationNonBorrowerEntityApi.editEntities(params);

  return dispatch({
    type: NON_BORROWER_ENTITIES_ACTION_TYPE.EDIT_ENTITIES,
    payload: data,
  });
});

export const createNonBorrowerEntityAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationNonBorrowerEntityApi.createEntity(params);

  return dispatch({
    type: NON_BORROWER_ENTITIES_ACTION_TYPE.CREATE_ENTITY,
    payload: data,
  });
});

export const deleteNonBorrowerEntityAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationNonBorrowerEntityApi.deleteEntity(params);

  return dispatch({
    type: NON_BORROWER_ENTITIES_ACTION_TYPE.DELETE_ENTITY,
    payload: data,
    meta: params,
  });
});
